import React from 'react';

/**
 * Monaco Editor 라인 하이라이트 스타일 컴포넌트
 */
const MonacoEditorStyles = () => {
  return (
    <style>{`
      /* Monaco Editor 커스텀 스타일 */
      .monaco-editor {
          padding: 0;
          user-select: none !important;
          -webkit-user-select: none !important;
          -moz-user-select: none !important;
          -ms-user-select: none !important;
      }
          
      .monaco-editor .selected-line-highlight {
          /* 선택된 라인 하이라이트 */
          background-color: rgba(0, 122, 204, 0.15) !important;
      }

      .monaco-editor .selected-line-glyph {
          /* 선택된 라인: 파란 배경의 체크박스에 흰색 체크 표시 */
          background-color: transparent !important;
          width: 18px !important;
          background-image: url("data:image/svg+xml;utf8,<svg width='16' height='16' xmlns='http://www.w3.org/2000/svg'><rect x='2' y='2' width='12' height='12' rx='2' style='fill:%23007acc;stroke:%23007acc;stroke-width:1'/><polyline points='4,8 7,11 12,5' style='fill:none;stroke:%23ffffff;stroke-width:2;stroke-linecap:round;stroke-linejoin:round'/></svg>");
          background-repeat: no-repeat;
          background-position: center;
          cursor: pointer !important;
          transition: opacity 0.2s ease !important;
      }

      .monaco-editor .unselected-line-glyph {
          /* 선택되지 않은 라인: 회색 테두리 체크박스 (클릭 가능) */
          background-color: transparent !important;
          width: 18px !important;
          background-image: url("data:image/svg+xml;utf8,<svg width='16' height='16' xmlns='http://www.w3.org/2000/svg'><rect x='2' y='2' width='12' height='12' rx='2' style='fill:none;stroke:%23666666;stroke-width:1.5'/></svg>");
          background-repeat: no-repeat;
          background-position: center;
          cursor: pointer !important;
          transition: opacity 0.2s ease !important;
      }

      .monaco-editor .unselected-line-glyph:hover {
          /* 호버 시 더 밝은 테두리로 피드백 제공 */
          background-image: url("data:image/svg+xml;utf8,<svg width='16' height='16' xmlns='http://www.w3.org/2000/svg'><rect x='2' y='2' width='12' height='12' rx='2' style='fill:none;stroke:%23999999;stroke-width:1.5'/></svg>");
      }

      /* 라인 번호 영역에 pointer 커서 적용 */
      .monaco-editor .margin,
      .monaco-editor .glyph-margin,
      .monaco-editor .line-numbers {
          cursor: pointer !important;
      }
    `}</style>
  );
};

export default MonacoEditorStyles;
